/**
 * Browser shim for Node `node:fs` imports that leak into the bundle from
 * server-only `@smart-shikka/core` modules. This shim exists only so the SPA
 * build can tree-shake unused server code paths; any function actually called
 * at runtime is a developer error and fails loudly.
 */

function notAvailable(name: string): (...args: unknown[]) => never {
  return () => {
    throw new Error(`node:fs.${name} is not available in the browser bundle`);
  };
}

export const access = notAvailable("access");
export const accessSync = notAvailable("accessSync");
export const appendFile = notAvailable("appendFile");
export const appendFileSync = notAvailable("appendFileSync");
export const chmod = notAvailable("chmod");
export const chmodSync = notAvailable("chmodSync");
export const chown = notAvailable("chown");
export const chownSync = notAvailable("chownSync");
export const close = notAvailable("close");
export const copyFile = notAvailable("copyFile");
export const copyFileSync = notAvailable("copyFileSync");
export const createReadStream = notAvailable("createReadStream");
export const createWriteStream = notAvailable("createWriteStream");
export const existsSync = notAvailable("existsSync");
export const fstat = notAvailable("fstat");
export const fsync = notAvailable("fsync");
export const ftruncate = notAvailable("ftruncate");
export const lstat = notAvailable("lstat");
export const lstatSync = notAvailable("lstatSync");
export const mkdir = notAvailable("mkdir");
export const mkdirSync = notAvailable("mkdirSync");
export const mkdtemp = notAvailable("mkdtemp");
export const mkdtempSync = notAvailable("mkdtempSync");
export const open = notAvailable("open");
export const openSync = notAvailable("openSync");
export const read = notAvailable("read");
export const readFile = notAvailable("readFile");
export const readFileSync = notAvailable("readFileSync");
export const readdir = notAvailable("readdir");
export const readdirSync = notAvailable("readdirSync");
export const readlink = notAvailable("readlink");
export const readlinkSync = notAvailable("readlinkSync");
export const realpath = notAvailable("realpath");
export const realpathSync = notAvailable("realpathSync");
export const rename = notAvailable("rename");
export const rmdir = notAvailable("rmdir");
export const rm = notAvailable("rm");
export const rmSync = notAvailable("rmSync");
export const stat = notAvailable("stat");
export const statSync = notAvailable("statSync");
export const symlink = notAvailable("symlink");
export const truncate = notAvailable("truncate");
export const unlink = notAvailable("unlink");
export const utimes = notAvailable("utimes");
export const write = notAvailable("write");
export const writeFile = notAvailable("writeFile");
export const writeFileSync = notAvailable("writeFileSync");
export const promises = {} as unknown as typeof import("node:fs").promises;

const fs = {
  access, accessSync, appendFile, appendFileSync, chmod, chmodSync, chown, chownSync,
  close, copyFile, copyFileSync, createReadStream, createWriteStream, existsSync, fstat,
  fsync, ftruncate, lstat, lstatSync, mkdir, mkdirSync, mkdtemp, mkdtempSync, open,
  openSync, read, readFile, readFileSync, readdir, readdirSync, readlink, readlinkSync,
  realpath, realpathSync, rename, rmdir, rm, rmSync, stat, statSync, symlink, truncate,
  unlink, utimes, write, writeFile, writeFileSync, promises,
};
export default fs;
